import React, { useContext } from 'react'
import { AuditPromiseClient } from '@trustero/trustero-api-web/lib/audit/audit_grpc_web_pb'
import {
  AuditRecord,
  GetReportRequest,
  Report,
  ReportType,
} from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { StringValue } from 'google-protobuf/google/protobuf/wrappers_pb'
import FileSaver from 'file-saver'
import log from 'loglevel'
import { toast } from 'react-toastify'
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { useAuthorizedGrpcClient } from '../../../../adapter'
import { useAudit } from '../../../../components/async/model/audit'
import { Spinner, ThrobberContext } from '../../../../Throbber'

const hasFinalReport = (audit?: AuditRecord) => {
  const reports = audit
    ?.getReportsList()
    .filter(
      (report: Report) =>
        report.getType() === ReportType.CLOSED_AUDIT_FINAL_PAPERS,
    )
    .sort((x: Report, y: Report) => {
      const xtime =
        x.getCreatedAt() || new Timestamp().setNanos(0).setSeconds(0)
      const ytime =
        y.getCreatedAt() || new Timestamp().setNanos(0).setSeconds(0)
      return xtime < ytime ? -1 : xtime > ytime ? 1 : 0
    })
  return reports?.pop()
}

const download = async (
  client: AuditPromiseClient,
  audit: AuditRecord,
  report: Report,
) => {
  try {
    const request = new GetReportRequest()
      .setAuditId(new StringValue().setValue(audit.getId()))
      .setType(ReportType.CLOSED_AUDIT_FINAL_PAPERS)
      .setName(new StringValue().setValue(report.getName()))
    const wp = await client.getReport(request)
    FileSaver.saveAs(wp.getUri() || '', report.getName())
  } catch (e) {
    log.error('error downloading final Report', e)
    toast.error(
      <div>{'There was a problem downloading the Final Report.'}</div>,
    )
  }
}

export const DownloadFinalReport = ({
  eventKey,
  auditId,
}: {
  eventKey: string
  auditId: string
}): JSX.Element => {
  const { data: audit } = useAudit(auditId)
  const { setThrobberState } = useContext(ThrobberContext)
  const client = useAuthorizedGrpcClient(AuditPromiseClient)
  const report = hasFinalReport(audit)

  if (!audit || !report) {
    return <></>
  }

  return (
    <BasicDropdownMenuItem
      eventKey={eventKey}
      onClick={async (e: React.MouseEvent) => {
        e.preventDefault()
        setThrobberState({
          isShown: true,
          Display: <Spinner color="primary" size="xl" />,
        })
        await download(client, audit, report)
        setThrobberState({
          isShown: false,
          Display: <></>,
        })
      }}
    >
      Download Stored Final Report
    </BasicDropdownMenuItem>
  )
}
